import api from './api';

class VirtualTransactionService {
  async getVirtualTransactions() {
    const response = await api.get('/v1/virtual-transactions');
    return response.data;
  }

  async getVirtualTransaction(id) {
    const response = await api.get(`/v1/virtual-transactions/${id}`);
    return response.data;
  }

  async createVirtualTransaction(data) {
    const response = await api.post('/v1/virtual-transactions', data);
    return response.data;
  }

  async updateVirtualTransaction(id, data) {
    const response = await api.put(`/v1/virtual-transactions/${id}`, data);
    return response.data;
  }

  async deleteVirtualTransaction(id) {
    const response = await api.delete(`/v1/virtual-transactions/${id}`);
    return response.data;
  }

  async toggleActive(id) {
    const response = await api.patch(`/v1/virtual-transactions/${id}/toggle-active`);
    return response.data;
  }
}

export default new VirtualTransactionService();
